import { useWorkflowCampaignNodesWithCh0 } from 'modules/workflows/hooks';
import { MessageMedium, EmbeddedMessageMedium } from 'constants/messageMediums';
import { TrimmedWorkflow } from '../CloneJourneyModal.types';
import { Campaign, CampaignNode } from './CloningCampaignsContext.types';

export const getErrorMsg = (msg: string, messageMedium?: MessageMedium | EmbeddedMessageMedium) => {
  if (typeof msg === 'string') {
    if (msg.includes('senders')) {
      return 'No sender available';
    }
    if (msg.includes('message types')) {
      return messageMedium === EmbeddedMessageMedium.Embedded
        ? `Can't copy to another project`
        : 'No message type available';
    }
  }
  return 'No message type or sender available';
};

export const getCampaignNodes = (workflow: TrimmedWorkflow) => {
  const campaigns = useWorkflowCampaignNodesWithCh0({
    workflowId: workflow.id,
    workflowType: workflow.workflowType,
  })?.allNodes as CampaignNode[];
  return campaigns
    ?.map((c) =>
      c?.resource?.campaign
        ? c?.resource?.campaign
        : c?.resource?.resources && c?.resource?.resources.map((r) => r?.campaign),
    )
    ?.flat() as Campaign[];
};
